export const CURRENCIES_CODES = {
  EUR: 'EUR',
};
